import React from "react";
import TrackingTypingBubble from "./TrackingTypingBubble";

/** Inline dots-only bubble — matches shipment / tracking chat */
export function TypingIndicatorBubble({ className = "" }) {
  return (
    <div className={className}>
      <TrackingTypingBubble />
    </div>
  );
}

const TypingIndicator = () => (
  <div className="flex justify-start mb-4">
    <TypingIndicatorBubble />
  </div>
);

export default TypingIndicator;
